/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, Input } from '@angular/core';
import { UploadDialogComponent } from './upload-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { LoggerService } from '../../../../shared/services/logger.service';
import { filter, switchMapTo } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { IsolatedReportService } from '../../../services/isolatedReport.service';
import { LoadDataForm } from '../../../state/dataForm.actions';
import { FileUploadDialogData } from './state/upload.model';

@Component({
    selector: 'dash-gis-upload',
    templateUrl: './upload.component.html',
})
export class UploadComponent {
    @Input() reportName: string;
    @Input() form: string;
    @Input() key: any;
    @Input() layer: string;
    @Input() allow: string;
    @Input() maxFiles: number;

    public constructor(
        private logger: LoggerService,
        private dialog: MatDialog,
        private isolatedReport: IsolatedReportService,
        private store: Store
    ) {}

    public showUploadDialog() {
        this.store
            .dispatch(new LoadDataForm({ name: this.form, keys: [this.key] }))
            .pipe(
                switchMapTo(
                    this.dialog
                        .open<UploadDialogComponent, FileUploadDialogData>(UploadDialogComponent, {
                            minWidth: '400px',
                            data: {
                                form: this.form,
                                key: this.key,
                                layer: this.layer,
                                accept: this.allow,
                                maxFiles: this.maxFiles,
                            },
                        })
                        .afterClosed()
                ),
                filter((b) => b)
            )
            .subscribe(() => this.isolatedReport.triggerReport());
    }
}
